// Others
import { urlApiJob } from '~/utils/constants/apis';
import { IBaseResponse } from '~/utils/interface/base';
import { IBaseDeleteBody, IQueryParamById } from '~/utils/interface/common';
import {
  IChangeStatusJobBody,
  IFormJob,
  IInvoiceJobDetails,
  IJob,
  IJobDetail,
  IJobDetailUpdate,
  IJobDetailUpdateReq,
  IJobListDataResponse,
  IParamScheduleForJobDetail,
  IParamsDetailJob,
  IQueryGetListJob,
  IUpdateJobBody,
} from '~/utils/interface/job';
import axiosClient from './axiosClient';
import { ISchedule, IScheduleTimeLine } from '~/utils/interface/schedule';

const jobApi = {
  createJob(payload: IFormJob) {
    const url = urlApiJob.createJob;
    return axiosClient.post<IBaseResponse>(url, payload);
  },

  getJobList(params: IQueryGetListJob) {
    const url = urlApiJob.getJobList;
    return axiosClient.get<IBaseResponse<IJobListDataResponse<IJob[]>>>(url, { params });
  },

  getJobDetail(params: IParamsDetailJob) {
    const url = urlApiJob.getJobDetail(params.jobId);
    return axiosClient.get<IBaseResponse<IJobDetail | IInvoiceJobDetails>>(url, {
      params: {
        type: params.type,
      },
    });
  },

  getJobListByCustomer(body: IQueryParamById) {
    const { id, params } = body;
    const url = urlApiJob.getJobListByCustomer(id);
    return axiosClient.get<IBaseResponse<IJobListDataResponse<IJob[]>>>(url, { params });
  },

  deleteJob(params: IBaseDeleteBody) {
    const url = urlApiJob.deleteJob;
    return axiosClient.delete<IBaseResponse>(url, { params });
  },

  updateJob({ jobId, body }: IUpdateJobBody) {
    const url = urlApiJob.updateJob(jobId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  changeStatus({ jobId, body }: IChangeStatusJobBody) {
    const url = urlApiJob.changeStatus(jobId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  getJobDetailUpdate(payload: IJobDetailUpdateReq) {
    const url = urlApiJob.getJobDetailUpdate(payload.jobId);
    return axiosClient.get<IBaseResponse<IJobDetailUpdate>>(url, { params: payload.params });
  },

  getScheduleList(payload: IParamScheduleForJobDetail) {
    const url = urlApiJob.getListSchedule(payload.jobId);
    return axiosClient.get<IBaseResponse<ISchedule[] | IScheduleTimeLine[]>>(url, {
      params: payload.params,
    });
  },
};

export default jobApi;
